import { useParams } from "next/navigation";
import { useCallback, useEffect, useState } from "react";

export function useWindowHash() {
  const [hash, setHash] = useState(window.location.hash);
  const params = useParams();

  const handleHashChange = useCallback(() => {
    setHash(window.location.hash);
  }, []);

  useEffect(() => {
    handleHashChange();
  }, [params]);

  useEffect(() => {
    window.addEventListener("popstate", handleHashChange);
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("popstate", handleHashChange);
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return hash;
}
